import { useDashboardOverview } from '@redbax/shared';
import {
  PageHeader,
  StatCard,
  CategoryDonut,
  TrendLine,
  DataTable,
  HorizontalBar,
  type Column,
} from '@redbax/ui-kit';
import { ShieldAlert, ShieldBan, AlertTriangle, FileText } from 'lucide-react';
import type { TopDeviceItem } from '@redbax/shared';

const topDeviceColumns: Column<TopDeviceItem>[] = [
  { key: 'deviceName', header: 'Device', sortable: true },
  { key: 'eventCount', header: 'Events', sortable: true },
];

export function DashboardPage() {
  const { data, isLoading } = useDashboardOverview(30);

  return (
    <div>
      <PageHeader title="Dashboard" description="Detection overview for the last 30 days" />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <StatCard
          title="Total Detections"
          value={data?.totalDetections ?? 0}
          change={data?.changePercent}
          icon={<ShieldAlert className="h-4 w-4" />}
          loading={isLoading}
        />
        <StatCard
          title="Blocked"
          value={data?.blocked ?? 0}
          icon={<ShieldBan className="h-4 w-4" />}
          loading={isLoading}
        />
        <StatCard
          title="Warned"
          value={data?.warned ?? 0}
          icon={<AlertTriangle className="h-4 w-4" />}
          loading={isLoading}
        />
        <StatCard
          title="Logged"
          value={data?.logged ?? 0}
          icon={<FileText className="h-4 w-4" />}
          loading={isLoading}
        />
      </div>

      <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-2">
        <CategoryDonut
          data={data?.categoryBreakdown ?? {}}
          loading={isLoading}
        />
        <TrendLine
          data={data?.trendData ?? []}
          loading={isLoading}
        />
      </div>

      <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-2">
        <div>
          <h2 className="mb-3 text-lg font-semibold text-text-primary">Top Devices</h2>
          <DataTable
            columns={topDeviceColumns}
            data={data?.topDevices ?? []}
            keyExtractor={(d) => d.deviceName}
            loading={isLoading}
            emptyMessage="No device data available"
          />
        </div>
        <HorizontalBar
          title="Top Services"
          data={(data?.topServices ?? []).map((s) => ({
            name: s.serviceName,
            value: s.eventCount,
          }))}
          loading={isLoading}
        />
      </div>
    </div>
  );
}
